import { DataStore } from 'aws-amplify'
import { Post, Content, Media } from '@/models'

const TYPEMAP = {
  'Post': Post,
  'Content': Content,
  'Media': Media
}

const getKlass = (type) => {
  const klass = TYPEMAP[type]
  if (!klass) {
    throw(`Invalid record type: ${type}`)
  }
  return klass
}

export const saveRecord = async (type, editable) => {
  const klass = getKlass(type)
  try {
    let model
    if (editable.id) {
      model = await DataStore.query(klass, editable.id)
      model = klass.copyOf(model, updated => Object.assign(updated, editable))
    } else {
      model = new klass(editable)
    }
    const record = await DataStore.save(model)
    // console.log('saved:', record)
    return record
  } catch (e) {
    console.warn(e)
  }
}

export const deleteRecord = async ({ type, id, record }) => {
  try {
    if (!record) {
      const klass = getKlass(type)
      record = await DataStore.query(klass, id)
    }
    await DataStore.delete(record)
    // console.log('deleted:', record)
    return true
  } catch (e) {
    console.warn(e)
  }
}
